<template>
	<nav aria-label="Page navigation" :class="{'opacity-50': loading}" v-if="pagesCount > 1">
		<ul class="pagination justify-content-center mb-0">
			<!-- Назад -->
			<li class="page-item" :class="{ 'disabled': modelValue <= 1 || loading }">
				<a
					class="page-link p-1"
					href="javascript://"
					@click.prevent="changePage(modelValue - 1)"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						width="28"
						height="28"
						fill="currentColor"
					>
						<path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
					</svg>
				</a>
			</li>

			<!-- Первая страница -->
			<li class="page-item" :class="{ 'active': modelValue == 1, 'disabled': loading }">
				<a
					class="page-link"
					href="javascript://"
					@click.prevent="changePage(1)"
				>1</a>
			</li>

			<!-- Разделитель слева -->
			<li class="page-item disabled" v-if="modelValue - alpha > 2">
				<span class="page-link">...</span>
			</li>

			<!-- Средние страницы (Range) -->
			<li
				class="page-item"
				v-for="i in middleRange"
				:key="i"
				:class="{ 'active': modelValue == i, 'disabled': loading }"
			>
				<a
					class="page-link"
					href="javascript://"
					@click.prevent="changePage(i)"
				>{{ i }}</a>
			</li>

			<!-- Разделитель справа -->
			<li
				class="page-item disabled"
				v-if="modelValue + alpha < pagesCount - 1"
			>
				<span class="page-link">...</span>
			</li>

			<!-- Последняя страница -->
			<li
				class="page-item"
				:class="{ 'active': modelValue == pagesCount, 'disabled': loading }"
				v-if="pagesCount > 1"
			>
				<a
					class="page-link"
					href="javascript://"
					@click.prevent="changePage(pagesCount)"
				>{{ pagesCount }}</a>
			</li>

			<!-- Вперед -->
			<li
				class="page-item"
				:class="{ 'disabled': modelValue >= pagesCount || loading }"
			>
				<a
					class="page-link p-1"
					href="javascript://"
					@click.prevent="changePage(modelValue + 1)"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						width="28"
						height="28"
						fill="currentColor"
					>
						<path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
					</svg>
				</a>
			</li>
		</ul>
	</nav>
</template>

<style lang="scss"></style>

<script>
export default {
	name: "PaginationComponent",
	props: {
		modelValue: { type: Number, default: 1 }, // Текущая страница (v-model)
		total: { type: Number, default: 0 }, // Общее кол-во записей
		limit: { type: Number, default: 25 }, // Лимит на страницу
		alpha: { type: Number, default: 3 }, // Сколько страниц показывать вокруг текущей
		loading: { type: Boolean, default: false }, // Загрузка
	},
	emits: ["update:modelValue", "change"],
	computed: {
		pagesCount() {
			return Math.ceil(this.total / this.limit);
		},
		middleRange() {
			const start = Math.max(this.modelValue - this.alpha, 2);
			const end = Math.min(
				this.modelValue + this.alpha,
				this.pagesCount - 1,
			);
			const range = [];
			for (let i = start; i <= end; i++) {
				range.push(i);
			}
			return range;
		},
	},
	methods: {
		changePage(page) {
			if (this.loading) return; 
			
			if (
				page >= 1 &&
				page <= this.pagesCount &&
				page !== this.modelValue
			) {
				this.$emit("update:modelValue", page);
				this.$emit("change", page);
			}
		},
	},
};
</script>
